<template>
  <div class="config_item">
    <span>{{ label }}：</span>
    <slot />
    <el-button v-if="powerReg('fa7b9c18d65758400c7bdf14bfbd350f')" size="small" class="ml10" :type="show ? 'primary' : 'text'" @click="saveDay">{{ show ? '保存' : '编辑' }}</el-button>
    <el-button v-if="show" size="small" class="ml10" type="text" @click="$emit('update:show', false)">取消</el-button>
    <slot v-if="$slots.tips" name="tips" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default() {
        return ''
      }
    },
    show: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    saveDay() {
      if (!this.show) {
        this.$emit('update:show', true)
      } else {
        this.$emit('save')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .config_item {
    .el-input{
      width: 180px;
    }
  }
}
</style>
